import { inject, Pipe, PipeTransform } from '@angular/core';
import { LotsService } from '../services/lots.service';

@Pipe({
  name: 'priceType',
  standalone: true,
})
export class PriceTypePipe implements PipeTransform {
  lotsService = inject(LotsService);
  transform(price: unknown, ...args: unknown[]): unknown {
    return this.lotsService.getPriceText(price);
  }
}
